import {useContext} from "react";
import {FiPlus} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {AddExternalUserButton} from "@/pages/statuspages/tabs/external-users/components/AddExternalUserButton.tsx";

interface EmptyExternalUsersProps {
  variant: "general" | "filter";
}

export const EmptyExternalUsers = ({variant}: EmptyExternalUsersProps) => {
  const {statusPage} = useContext(StatusPageContext);
  if (variant === "filter") {
    return <span className="p-2 py-3">No External Users found matching the filter(s) above.</span>;
  }
  return (
    <div className="d-flex flex-column align-items-center justify-content-center gap-3 py-4">
      <div className="pulseTextBodyBold">You have not yet invited any External Users.</div>
      <div className="pulseTextBodySmall">
        Invite a non-account user to securely access this Status Page.{" "}
        <a
          className="pulseTextLinkBold"
          href="https://support.uptime.com/hc/en-us/articles/6801239386652-Securing-Your-Uptime-com-Status-Page#access_external"
          target={"_blank"}
        >
          View Documentation
        </a>
      </div>
      <div className="d-flex justify-content-center">
        <AddExternalUserButton statusPageID={statusPage.id} variant="secondary">
          <Icon icon={FiPlus} /> New External User
        </AddExternalUserButton>
      </div>
    </div>
  );
};
